import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import SiteLayout from "./components/SiteLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import WorkPage from "./pages/WorkPage";
import BeforeAfterPage from "./pages/BeforeAfterPage";
import GuaranteesPage from "./pages/GuaranteesPage";
import ContactPage from "./pages/ContactPage";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import AdminSetup from "./pages/AdminSetup";
import Admin from "./pages/Admin";
import Portal from "./pages/Portal";

const NoiseOverlay = () => <div className="noise-overlay" aria-hidden="true" />;

const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-gold font-serif text-xl">…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!["admin", "staff"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <NoiseOverlay />
          <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#0f0f0f", border: "1px solid rgba(212,175,55,0.3)", color: "#fff" } }} />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetailPage />} />
              <Route path="/work" element={<WorkPage />} />
              <Route path="/before-after" element={<BeforeAfterPage />} />
              <Route path="/guarantees" element={<GuaranteesPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/setup" element={<AdminSetup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
